export type ListPageArgs = {
  page: number
  perPage: number
  query: string
}

export type ApiPaginationParams = {
  page: number
  per_page: number
  query?: string
}

export function toApiPagination({
  page,
  perPage,
  query,
}: ListPageArgs): ApiPaginationParams {
  const params: ApiPaginationParams = {
    page,
    per_page: perPage,
  }
  const trimmed = query.trim()
  if (trimmed) {
    params.query = trimmed
  }
  return params
}
